export enum PAYMENT_STATUS {
  unavailable = 'unavailable',
  peding = 'pending',
  scheduled = 'scheduled',
  paid = 'paid',
  overdue = 'overdue',
  covered_with_care = 'covered_with_care'
}

export const PAYMENT_STATUS_LABELS: Record<PAYMENT_STATUS, string> = {
  pending: 'Pendiente de pago',
  scheduled: 'Programado',
  overdue: 'Vencido',
  paid: 'Pagado',
  unavailable: 'No disponible',
  covered_with_care: 'Cubierto con Care'
};

interface PaymentStatusStyle {
  backgroundColor: string;
  color: string;
  borderColor?: string;
}

export const PAYMENT_STATUS_COLORS: Record<PAYMENT_STATUS, PaymentStatusStyle> = {
  pending: {
    backgroundColor: 'bg-nudos-yellow-300',
    color: 'text-nudos-yellow-300',
    borderColor: 'border-nudos-yellow-300'
  },
  scheduled: {
    backgroundColor: 'bg-nudos-blue',
    color: 'text-nudos-blue'
  },
  overdue: {
    backgroundColor: 'bg-nudos-red-error',
    color: 'text-nudos-red-error',
    borderColor: 'border-nudos-red-error'
  },
  paid: {
    backgroundColor: 'bg-nudos-green-400',
    color: 'text-nudos-green-400',
    borderColor: 'border-transparent'
  },
  unavailable: {
    backgroundColor: 'bg-nudos-gray-500',
    color: 'text-nudos-gray-500',
    borderColor: 'border-transparent'
  },
  covered_with_care: {
    backgroundColor: 'bg-nudos-green-400',
    color: 'text-nudos-green-400',
    borderColor: 'border-transparent'
  }
};
